<template>
  <div class="pc-filter">
    <SortFilter v-model:sort="sort" />
    <div class="pc-filter-price">
      <input
        class="pc-filter-price__input"
        v-model.number="price.min"
        :placeholder="`Low (${currency.current.targetCurrency} ${currency.current.targetUnit})`"
        type="number"
      >
      <span>to</span>
      <input
        class="pc-filter-price__input"
        v-model.number="price.max"
        :placeholder="`High (${currency.current.targetCurrency} ${currency.current.targetUnit})`"
        type="number"
      >
      <button
        class="pc-filter-price__done"
        v-if="isPriceValid"
        @click="onSubmit"
      >
        Done
      </button>
    </div>
  </div>
</template>

<script setup>
import SortFilter from './SortFilter.vue'
import { useCurrencyStore } from '@/pinia/currency'

const currency = useCurrencyStore()

const emit = defineEmits(['done'])

const sort = defineModel('sort', { type: Object, default: () => ({}) })

const priceStart = defineModel('priceStart', { type: [Number, String], default: null })

const priceEnd = defineModel('priceEnd', { type: [Number, String], default: null })

const price = reactive({ min: priceStart.value, max: priceEnd.value })

watch(() => [priceStart.value, priceEnd.value], ([min, max]) => {
  price.min = min
  price.max = max
})

const isPriceValid = computed(() => {
  return priceStart.value || priceEnd.value || Number(priceStart.value) !== Number(price.min) || Number(priceEnd.value) !== Number(price.max)
})

const onSubmit = () => {
  priceStart.value = price.min
  priceEnd.value = price.max
  emit('done')
}
</script>

<style lang="less" scoped>
.pc-filter {
  display: flex;
  align-items: center;
  gap: 12px;

  &-price {
    margin-left: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: mon-500;
    font-size: 12px;

    &__input {
      width: 100px;
      height: 24px;
      border-radius: 4px;
      border: 1px solid #ebf1f5;
      color: #5c5c5c;
      font-family: mon-500;
      font-size: 11px;
      outline: none;
      text-align: center;

      &[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      &::placeholder {
        color: #B2B7C2;
      }

      &:focus::placeholder {
        color: #EBEBEB;
      }

      &:focus, &:hover {
        border: 1px solid #232323;
      }
    }

    > span {
      color: #6E717A;
    }

    &__done {
      margin-left: 4px;
      padding: 4px 12px;
      border-radius: 4px;
      border: none;
      background: #232323;
      font-family: mon-500;
      font-size: 12px;
      line-height: 16px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>
